import styled from 'styled-components';
export const DynamicFormWrapper = styled.div `
position: relative;
  h4 {
    margin-bottom: 25px;
  }
  ${props => props.maxWidth && `
    max-width: ${props.maxWidth};
    margin: auto;
  `};

  form {
    display: flex;
    flex-direction: column;
  }
  button {
    align-self: ${props => props.buttonPosition};
  }
`;
export const DynamicFormGrid = styled.div `
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 14px;
  margin-bottom: 35px;
  .dynamic-form-checkbox {
    font-size: 14px;
  }
`;
export const FormServerErrors = styled.div `
  color: ${props => props.theme.colors.error};
  margin-bottom: 15px;
`;
export const DynamicFormRow = styled.div `
  grid-column: ${props => props.split ? 'span 1' : '1 / span 2'};
  input[type="checkbox"] + div {
    font-size: 14px;
  }
  input::placeholder {
    color: #bababa !important;
  }
`;
export const RadioWrapper = styled.div `
  padding: 2px 0;
`;
export const RadioErrorMessage = styled.div `
  margin-top: 5px;
  color: ${props => { var _a, _b; return (_b = (_a = props.theme) === null || _a === void 0 ? void 0 : _a.colors) === null || _b === void 0 ? void 0 : _b.error; }};
`;
export const DynamicFormRadioWrapper = styled.div ``;
export const DynamicFormRadioLabel = styled.div `
  font-weight: 600;
`;
export const DynamicFormLabelField = styled.h4 `
  font-weight: 700;
  margin-top: 15px;
  margin-bottom: 5px !important;
`;
export const DynamicFormAfterContent = styled.div `
  padding-bottom: 30px;
  white-space: pre-wrap;
`;
export const InnerFormWrapper = styled.div `
  width: 100%;
`;
